// WON: the file a user may add when setting a quote Won. Every Won dialog's addWonDetails uses
// this: no file chosen, no request (it used to POST an empty file and get a silent 400); a failed
// upload says so. The Won itself is saved separately and is not affected.
export function postWonFile(attachmentService, toast, file, quoteVerId) {
  if (!(file && file.name)) return null

  return attachmentService
    .postFile(file, { fileName: file.name, quotation: quoteVerId })
    .then(res => {
      toast.add({
        severity: 'success',
        summary: `${(res && res.data && res.data.fileName) || file.name} uploaded`,
        detail: 'File uploaded',
        life: 5000
      })
    })
    .catch(err => {
      const data = err && err.response && err.response.data
      if (typeof data === 'string' && data.includes('exceeds the configured maximum')) {
        toast.add({ severity: 'error', summary: 'File too big.', detail: 'File size exceeds the limited size.', life: 5000 })
      } else {
        toast.add({
          severity: 'error',
          summary: 'File not uploaded',
          detail: `The quote is Won, but ${file.name} was not uploaded. Add it from the quote's Attachments tab.`,
          life: 8000
        })
      }
    })
}
